'use strict';

angular.module('directives.placeholder', [])

.directive('placeholder', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var placeholder = attrs.placeholder;
            if (placeholder) {
                $(element).placeholder();
            }
        }
    };
})